"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertCimdocCommandsToCimDocModule = exports.getColor = exports.convertPathCommandsToCimdoc = void 0;
const svg_arc_to_cubic_bezier_1 = __importDefault(require("svg-arc-to-cubic-bezier"));
const constants_1 = require("../constants");
const utility_curve_1 = require("./utility.curve");
const commandMap = {
    moveto: 'moveTo',
    lineto: 'lineTo',
    curveto: 'curveTo',
    closepath: 'close',
};
function getReflection(p1, center) {
    return {
        x: 2 * center.x - p1.x,
        y: 2 * center.y - p1.y,
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function convertCimDocCommandToGenericCommand(cimDocCommand) {
    // TODO : in future we will have to add conversion of other commands too.
    return {
        code: 'C',
        command: 'curveto',
        x: cimDocCommand.position.x,
        y: cimDocCommand.position.y,
        x0: cimDocCommand.start.x,
        y0: cimDocCommand.start.y,
        x1: cimDocCommand.controlPoint1.x,
        y1: cimDocCommand.controlPoint1.y,
        x2: cimDocCommand.controlPoint2.x,
        y2: cimDocCommand.controlPoint2.y,
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function commandToCimdocCommand(command) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cimdocCommand = {
        operation: commandMap[command.command],
    };
    if (command.x !== undefined && command.y !== undefined) {
        cimdocCommand.position = {
            x: command.x,
            y: command.y,
        };
    }
    if (command.x1 !== undefined && command.y1 !== undefined) {
        cimdocCommand.controlPoint1 = {
            x: command.x1,
            y: command.y1,
        };
    }
    if (command.x2 !== undefined && command.y2 !== undefined) {
        cimdocCommand.controlPoint2 = {
            x: command.x2,
            y: command.y2,
        };
    }
    cimdocCommand.start = {
        x: command.x0,
        y: command.y0,
    };
    return cimdocCommand;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function convertPathCommandsToCimdoc(commands) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cimdocPathCommands = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let previousCommand;
    for (let i = 0; i < commands.length; i++) {
        const originalCommand = commands[i];
        const commandCopy = Object.assign({}, originalCommand);
        if (commandCopy.command === 'horizontal lineto') {
            commandCopy.command = 'lineto';
            commandCopy.y = commandCopy.y0;
        }
        if (commandCopy.command === 'vertical lineto') {
            commandCopy.command = 'lineto';
            commandCopy.x = commandCopy.x0;
        }
        if (commandCopy.command === 'smooth curveto') {
            commandCopy.command = 'curveto';
            const cp1 = getReflection({
                x: previousCommand.x2 || commandCopy.x0,
                y: previousCommand.y2 || commandCopy.y0,
            }, {
                x: previousCommand.x,
                y: previousCommand.y,
            });
            commandCopy.x1 = cp1.x;
            commandCopy.y1 = cp1.y;
        }
        if (commandCopy.command === 'quadratic curveto') {
            commandCopy.command = 'curveto';
            // reference: https://fontforge.org/docs/techref/bezier.html#converting-truetype-to-postscript
            const cp1 = {
                x: commandCopy.x0 + (2 / 3) * (commandCopy.x1 - commandCopy.x0),
                y: commandCopy.y0 + (2 / 3) * (commandCopy.y1 - commandCopy.y0),
            };
            const cp2 = {
                x: commandCopy.x + (2 / 3) * (commandCopy.x1 - commandCopy.x),
                y: commandCopy.y + (2 / 3) * (commandCopy.y1 - commandCopy.y),
            };
            commandCopy.x1 = cp1.x;
            commandCopy.y1 = cp1.y;
            commandCopy.x2 = cp2.x;
            commandCopy.y2 = cp2.y;
        }
        if (commandCopy.command === 'smooth quadratic curveto') {
            commandCopy.command = 'curveto';
            const quadraticCp = getReflection({
                x: previousCommand.x1 || commandCopy.x0,
                y: previousCommand.y1 || commandCopy.y0,
            }, {
                x: previousCommand.x,
                y: previousCommand.y,
            });
            const cp1 = {
                x: commandCopy.x0 + (2 / 3) * (quadraticCp.x - commandCopy.x0),
                y: commandCopy.y0 + (2 / 3) * (quadraticCp.y - commandCopy.y0),
            };
            const cp2 = {
                x: commandCopy.x + (2 / 3) * (quadraticCp.x - commandCopy.x),
                y: commandCopy.y + (2 / 3) * (quadraticCp.y - commandCopy.y),
            };
            commandCopy.x1 = cp1.x;
            commandCopy.y1 = cp1.y;
            commandCopy.x2 = cp2.x;
            commandCopy.y2 = cp2.y;
        }
        if (commandCopy.command === 'elliptical arc') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const curveFromArcCommands = svg_arc_to_cubic_bezier_1.default({
                px: previousCommand.x,
                py: previousCommand.y,
                cx: commandCopy.x,
                cy: commandCopy.y,
                rx: commandCopy.rx,
                ry: commandCopy.ry,
                xAxisRotation: commandCopy.xAxisRotation,
                largeArcFlag: commandCopy.largeArc ? 1 : 0,
                sweepFlag: commandCopy.sweep ? 1 : 0,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const curveCommands = curveFromArcCommands.map((curve, index) => {
                const lastCurve = index > 0 ? curveFromArcCommands[index - 1] : previousCommand;
                return Object.assign(Object.assign({}, curve), { x0: lastCurve.x, y0: lastCurve.y, command: 'curveto' });
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const cimdocCommands = curveCommands.map((curveCommand) => commandToCimdocCommand(curveCommand));
            const lastCimdocCommand = cimdocCommands[cimdocCommands.length - 1];
            previousCommand = convertCimDocCommandToGenericCommand(lastCimdocCommand);
            cimdocPathCommands.push(...cimdocCommands);
        }
        else {
            const cimdocCommand = commandToCimdocCommand(commandCopy);
            previousCommand = originalCommand;
            cimdocPathCommands.push(cimdocCommand);
        }
    }
    return cimdocPathCommands;
}
exports.convertPathCommandsToCimdoc = convertPathCommandsToCimdoc;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getBoundingBox(cimdocPathCommands) {
    const boundingBox = {
        left: Infinity,
        top: -Infinity,
        right: -Infinity,
        bottom: Infinity,
    };
    for (let i = 0; i < cimdocPathCommands.length; i++) {
        const command = cimdocPathCommands[i];
        const positionX = parseFloat(command.position.x);
        const positionY = parseFloat(command.position.y);
        if (command.controlPoint1 && command.controlPoint2) {
            const bounds = utility_curve_1.getBoundsOfCurve(command.start, command.controlPoint1, command.controlPoint2, command.position);
            boundingBox.left = Math.min(boundingBox.left, bounds.left);
            boundingBox.bottom = Math.min(boundingBox.bottom, bounds.top);
            boundingBox.right = Math.max(boundingBox.right, bounds.right);
            boundingBox.top = Math.max(boundingBox.top, bounds.bottom);
        }
        else {
            boundingBox.left = Math.min(boundingBox.left, positionX);
            boundingBox.bottom = Math.min(boundingBox.bottom, positionY);
            boundingBox.right = Math.max(boundingBox.right, positionX);
            boundingBox.top = Math.max(boundingBox.top, positionY);
        }
    }
    return boundingBox;
}
function getColor(defaultColor, color) {
    let finalColor;
    if (!color || (color && color === 'none')) {
        finalColor = defaultColor;
    }
    else {
        const hexColor = color.slice(1);
        if (hexColor.length === 3) {
            finalColor = `#${hexColor
                .split('')
                .map((hex) => `${hex}${hex}`)
                .join('')}`;
        }
        else {
            finalColor = color;
        }
    }
    return finalColor;
}
exports.getColor = getColor;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function convertCimdocCommandsToCimDocModule({ cimdocPathCommands, pathProperties, widthInMM, heightInMM, }) {
    let dashPatternSegments = [];
    const boundingBox = getBoundingBox(cimdocPathCommands);
    const mmDimension = {
        width: boundingBox.right - boundingBox.left,
        height: boundingBox.top - boundingBox.bottom,
    };
    const aspectRatio = mmDimension.width / mmDimension.height;
    if (widthInMM) {
        mmDimension.width = widthInMM;
        mmDimension.height = widthInMM / aspectRatio;
    }
    else if (heightInMM) {
        mmDimension.height = heightInMM;
        mmDimension.width = heightInMM * aspectRatio;
    }
    else {
        throw new Error('Atleast one value in widthInMM or heightInMM should be provided.');
    }
    const curvesInMM = cimdocPathCommands.map((curve) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const cimdocCommand = {
            operation: curve.operation,
        };
        if (curve.position) {
            cimdocCommand.position = {
                x: `${curve.position.x}mm`,
                y: `${curve.position.y}mm`,
            };
        }
        if (curve.controlPoint1) {
            cimdocCommand.controlPoint1 = {
                x: `${curve.controlPoint1.x}mm`,
                y: `${curve.controlPoint1.y}mm`,
            };
        }
        if (curve.controlPoint2) {
            cimdocCommand.controlPoint2 = {
                x: `${curve.controlPoint2.x}mm`,
                y: `${curve.controlPoint2.y}mm`,
            };
        }
        return cimdocCommand;
    });
    if (pathProperties.dashArray) {
        dashPatternSegments = pathProperties.dashArray.split(/[ ,]+/).map((segment) => {
            return {
                length: segment.toString(),
            };
        });
    }
    return {
        type: 'curve',
        position: {
            x: `0mm`,
            y: `0mm`,
            height: `${mmDimension.height}mm`,
            width: `${mmDimension.width}mm`,
        },
        curves: curvesInMM,
        viewBox: {
            x: `${boundingBox.left}mm`,
            y: `${boundingBox.bottom}mm`,
            width: `${boundingBox.right - boundingBox.left}mm`,
            height: `${boundingBox.top - boundingBox.bottom}mm`,
        },
        stroke: Object.assign(Object.assign(Object.assign({ color: `rgb(${getColor(constants_1.SvgDefaults.strokeColor, pathProperties.strokeColor)})`, thickness: `${pathProperties.strokeWidth || constants_1.SvgDefaults.strokeWidth}pt` }, (pathProperties.lineCap && { lineCap: pathProperties.lineCap })), (pathProperties.lineJoin && { lineJoin: pathProperties.lineJoin })), (dashPatternSegments.length > 0 && {
            dashPattern: {
                segments: dashPatternSegments,
            },
        })),
        color: `rgb(${getColor(constants_1.SvgDefaults.fillColor, pathProperties.fill)})`,
    };
}
exports.convertCimdocCommandsToCimDocModule = convertCimdocCommandsToCimDocModule;
//# sourceMappingURL=utility.cimdoc.js.map